import React from 'react';
import {useTranslation} from 'react-i18next';
import {IV_DOCUMENT_IMAGE_TYPES} from '@guestapp/sdk';
import {PATHS} from 'routes/constants';
import {useFetchIVLottie} from 'hooks';
import {useIVRemoteSync} from 'hooks/iv/useIVRemoteSync';
import {useReservation} from 'context/reservation';
import checkIcon from '../../../../assets/icons/check.svg?no-inline';
import Button from 'components/common/Button';
import {ModalTwoButtonsWrapper} from 'styled/common';
import {
  BottomBlock,
  HelpersBlock,
  HelpersItem,
  StyledLottieIVDocumentsAnimations,
  Wrapper,
} from './styled';

function SelfieInstructionsView() {
  useIVRemoteSync();
  const {t} = useTranslation('identity-verification');
  const {housing} = useReservation();
  const {animationData: ivLottieAnimation} = useFetchIVLottie({
    type: IV_DOCUMENT_IMAGE_TYPES.selfie,
  });

  return (
    <Wrapper className="iv-upload-type-view">
      <StyledLottieIVDocumentsAnimations loop animationData={ivLottieAnimation} />
      <BottomBlock className="iv-upload-type-view__bottom">
        <HelpersBlock>
          {housing?.is_liveness_detection_enabled && (
            <HelpersItem>
              <img src={checkIcon} width={24} height={24} alt="" />
              <p>{t('liveness_detection.helpers.keep_face_in_oval')}</p>
            </HelpersItem>
          )}
          <HelpersItem>
            <img src={checkIcon} width={24} height={24} alt="" />
            <p>{t('liveness_detection.helpers.uncovered_face')}</p>
          </HelpersItem>
          <HelpersItem>
            <img src={checkIcon} width={24} height={24} alt="" />
            <p>{t('liveness_detection.helpers.good_lighting')}</p>
          </HelpersItem>
        </HelpersBlock>
        <ModalTwoButtonsWrapper className="iv-upload-type-view__buttons">
          <Button
            label={t('understood')}
            to={`../${PATHS.verification.selfie}`}
            outlined
          />
        </ModalTwoButtonsWrapper>
      </BottomBlock>
    </Wrapper>
  );
}

export {SelfieInstructionsView};
